import Shiksha from '../Images/ProjectDetails/ShikshaSeSakshamProjectDetail.png';
import ShikshaSeSakshamNeed1 from '../Images/ProjectDetails/ShikshaSeSakshamNeed1.png';
import ShikshaSeSakshamNeed2 from '../Images/ProjectDetails/ShikshaSeSakshamNeed2.png';
import ShikshaSeSakshamNeed3 from '../Images/ProjectDetails/ShikshaSeSakshamNeed3.png';
import ShikshaImpact from '../Images/ProjectDetails/ShikshaImpact.png';

import UdaanProject from '../Images/ProjectDetails/UdaanProject.png';
import UdaanNeed1 from '../Images/ProjectDetails/UdaanNeed.png';
import UdaanNeed2 from '../Images/ProjectDetails/UdaanNeed2.png';
import UdaanNeed3 from '../Images/ProjectDetails/UdaanNeed3.png';
import UdaanImpact from '../Images/ProjectDetails/UdaanImpact.png';
import SSSJoin from '../Images/ProjectDetails/SSSJoin.png';
import Child1 from '../Images/ProjectDetails/Child1.png';
import Saurvi from '../Images/ProjectDetails/Saurvi.jpg';
import Saurvi1 from '../Images/ProjectDetails/Saurvi (1).jpg';
import Saurvi2 from '../Images/ProjectDetails/Saurvi (2).jpg';
import Saurvi3 from '../Images/ProjectDetails/Saurvi (3).jpg';
import Saurvi4 from '../Images/ProjectDetails/Saurvi (4).jpg';
import Saurvi6 from '../Images/ProjectDetails/Saurvi (6).jpg';

import Saurvi7 from '../Images/ProjectDetails/Saurvi (7).jpg';
import Unnati from '../Images/ProjectDetails/Unnati (6).png';
import Unnati1 from '../Images/ProjectDetails/Unnati (1).png';
import Unnati2 from '../Images/ProjectDetails/Unnati (2).png';
import Unnati3 from '../Images/ProjectDetails/Unnati (3).png';
import Unnati4 from '../Images/ProjectDetails/Unnati (4).png';
import Unnati5 from '../Images/ProjectDetails/Unnati (5).png';
import Sarvodaya1 from '../Images/ProjectDetails/Sarvodaya (1).png';
import Sarvodaya2 from '../Images/ProjectDetails/Sarvodaya (2).png';
import Sarvodaya3 from '../Images/ProjectDetails/Sarvodaya (3).png';
import Sarvodaya4 from '../Images/ProjectDetails/Sarvodaya (4).png';
import Sarvodaya5 from '../Images/ProjectDetails/Sarvodaya (5).png';
import Sarvodaya6 from '../Images/ProjectDetails/Sarvodaya (6).png';
import Sahayak1 from '../Images/ProjectDetails/Sahayak (1).png';
import Sahayak2 from '../Images/ProjectDetails/Sahayak (2).png';
import KushalSakhi1 from '../Images/ProjectDetails/KushalSakhi (1).png';
import KushalSakhi2 from '../Images/ProjectDetails/KushalSakhi (2).png';
import KushalSakhi3 from '../Images/ProjectDetails/KushalSakhi (3).png';
import KushalSakhi4 from '../Images/ProjectDetails/KushalSakhi (5).png';
import KushalSakhi5 from '../Images/ProjectDetails/KushalSakhi (6).png';
import KushalSakhi6 from '../Images/ProjectDetails/KushalSakhi (7).png';
import Swasthya1 from '../Images/ProjectDetails/Swasthya (1).jpg';
import Swasthya2 from '../Images/ProjectDetails/Swasthya (2).jpg';
import Swasthya3 from '../Images/ProjectDetails/Swasthya (4).jpg';
import Swasthya4 from '../Images/ProjectDetails/Swasthya (5).jpg';
import Swasthya5 from '../Images/ProjectDetails/Swasthya (6).jpg';
import Swasthya6 from '../Images/ProjectDetails/Swasthya (7).jpg';
const projects = [
    {
      id: 2,
      pagename: "Shiksha Se Saksham",
      firstComponent: {
        image: Shiksha,
        heading: "Empowering Underprivileged Children in Chhalera Community",
        description: "Ishya Foundation, dedicated to educational equity, proudly presents Project Shiksha Se Saksham. Launched in November 2023, this initiative transforms lives in Chhalera village, Delhi, by providing underprivileged children with access to quality education and empowering their families.",
      },
      theNeed: {
        images: [
          ShikshaSeSakshamNeed1,
          ShikshaSeSakshamNeed2,
          ShikshaSeSakshamNeed3
        ],
        descriptions: [
          "Through a comprehensive baseline study, Ishya Foundation identified the critical need in Chhalera village.",
          "Lack of access to education: Many children within 300 households lacked formal schooling opportunities.",
          "Poverty: Financial constraints prevented families from affording education for their children.",
        ],
      },
      theImpact: {
        subheading: "Project Shiksha Se Saksham creates a ripple effect:",
        points: [
          "Empowering children: Education equips them with knowledge, skills, and confidence to thrive.",
          "Strengthening families: Parents gain insights into their child's progress, fostering a supportive learning environment.",
          "Building a brighter future: Breaking the cycle of poverty through education creates opportunities for children and their families.",
          
        ],
        image: ShikshaImpact,
      },
      JoinUs: {
        heading: "Join Us in Making a Difference:",
        description: "Project Shiksha Se Saksham is making a tangible difference in Chhalera village. Your contribution, however big or small, can support this critical initiative. Donate, volunteer, or spread the word! Together, let's empower children through education!",
        image: SSSJoin,
      },
      quote: "The best way to predict the future is to create it."

    },
    {
      id: 1,
      pagename: "Udaan",
      firstComponent: {
        image: UdaanProject,
        heading: "Empowering Out-of-School Children",
        description: "Ishya Foundation, a passionate advocate for education, proudly presents Project Udaan. This initiative tackles the critical issue of out-of-school children in Delhi, aiming to empower them through quality education.",
      },
      theNeed: {
        images: [
          UdaanNeed1,
          UdaanNeed2,
          UdaanNeed3,
        ],
        descriptions: [
          "Financial constraints: Poverty prevents families from affording school expenses.",
          "Family circumstances: Children may be burdened with household responsibilities.",
          "Lack of documentation: Incomplete documents can hinder enrollment in government schools.",
        ],
      },
      theImpact: {
        subheading: "Project Udaan creates a ripple effect:",
        points: [
          "Breaks the cycle of poverty: Education empowers children to break free from poverty and create brighter futures.",
          "Unlocks potential: Quality education equips children with knowledge and skills to reach their full potential.",
          "Empowers communities: Educated children become active contributors to a thriving society.",
        
        ],
        image: UdaanImpact,
      },
      
      JoinUs: {
        heading: "JOIN US",
        description: "Be a part of our journey to make a difference. Join hands with us and help create a better tomorrow.",
        image: "/path/to/circular-image.jpg",
      },
      testimonials: {
        heading: "What Our Supporters Say",
        subheading: "Here’s what people say about Project Shiksha Se Saksham",
        data: [
          {
            name: "John Doe",
            occupation: "Volunteer",
            image: Child1,
            stars: 5,
            quote: "This project has changed so many lives in Chhalera village!",
            paragraph: "Being part of this initiative has been incredibly rewarding. The work being done here is truly transforming lives, and I am proud to be a part of it.",
          },
          {
            name: "Jane Smith",
            occupation: "Donor",
            image:  Child1,
            stars: 5,
            quote: "I believe in the power of education.",
            paragraph: "I have seen firsthand how this project has impacted children in the community. The difference is clear, and I am honored to support such a meaningful cause.",
          },
          {
            name: "Sam Wilson",
            occupation: "Educator",
            image:  Child1,
            stars: 5,
            quote: "Education is the key to breaking the cycle of poverty.",
            paragraph: "Project Shiksha Se Saksham is doing incredible work. The children’s progress is impressive, and it’s exciting to see the ripple effect this project is creating.",
          },
        ],
      },
      quote: "We make a living by what we get, but we make a life by what we give. - Winston Churchill"

    },
    {
      id: 3,
      pagename: "Saurvi",
      firstComponent: {
        image: Saurvi3,
        heading: "Empowering Care Leavers in Delhi with Skills and Support",
        description: "Ishya Foundation, a non-profit dedicated to empowering Care leavers, proudly presents Project Saurvi. This innovative initiative focuses on providing holistic support and skill development of the underprivileged youth.",
      },
      theNeed: {
        images: [
          Saurvi1,
          Saurvi2,
          Saurvi
        ],
        descriptions: [
          "Skill Development and Education: Access to life skills training, vocational workshops, and resources for independence and sustainable careers.",
          "Mental Health Support: Professional counseling, peer groups, and initiatives to foster emotional resilience and wellbeing.",
          "Inclusive Community Platform: A safe space for care leavers to connect, learn, and grow together.",
         
        ],
      },
      theImpact: {
        subheading: "Project Saurvi's Impact:",
        points: [
          "Empowers care leavers to transition successfully into adulthood.",
          "Improves mental health and well-being.",
          "Increases employability and earning potential.",
          "Promotes self-confidence and independence.",
        ],
        image: Saurvi7,
      },
      JoinUs: {
        heading: "JOIN US",
        description: "Be a part of our journey to make a difference. Join hands with us and help create a better tomorrow.",
        image: Saurvi4,
      },
      quote: "You can give without loving, but you cannot love without giving. - Amy Carmichael"

    },
    {
      id: 4,
      pagename: "Sarvodaya",
      firstComponent: {
        image: Sarvodaya1,
        heading: "Sarvodaya - Universal Upliftment",
        description: "Universal Upliftment to provide remedial classes for students affected by the shortage of English teachers to their school in Alwar, Rajasthan. Ever since starting work in Alwar, Ishya Foundation has organised coaching classes for academically weak students, supplied stationary, provided financial support to students in need and organised English speaking classes for them. Under Project Sarvodaya, we have also adopted 6 government schools that were severely affected by Covid-19, some facing closures. The students at these schools were promoted without any tuition and were faced with the challenge of having no teachers to continue education. We ventured out to provide tuition to these schools through our resources and help do our bit in supporting the students with their academics.",
      },
      theNeed: {
        images: [
          Sarvodaya2,
          Sarvodaya3,
          Sarvodaya4
        ],
        descriptions: [
          "Skilled Educators and Resources: Recruitment of qualified teachers and provision of study materials, stationary, and infrastructure to support effective learning.",
          "Financial Assistance: Support for economically disadvantaged students to ensure access to education and reduce dropout rates.",
          "Academic Monitoring: Regular assessments and feedback to improve teaching methods and track student progress.",
         
        ],
      },
      theImpact: {
        subheading: "Project Saurvi's Impact:",
        points: [
          "Improved Academic Performance: 1438 students received remedial education, boosting their academic confidence and capabilities.",
          "Access to Education: Prevented closures and supported 6 government schools severely impacted by COVID-19, ensuring continuity of education.",
          "Enhanced English Proficiency: Organized English-speaking classes, equipping students with critical language skills for better opportunities.",
          "Support for Vulnerable Students: Provided financial aid and resources to academically weak and underprivileged students, reducing dropout rates.",
          "Community Upliftment: Strengthened educational foundations in Alwar, Rajasthan, contributing to long-term societal growth and upliftment.",
        ],
        image: Sarvodaya5,
      },
      JoinUs: {
        heading: "JOIN US",
        description: "Be a part of our journey to make a difference. Join hands with us and help create a better tomorrow.",
        image: Sarvodaya6,
      },
      quote: "The meaning of life is to find your gift. The purpose of life is to give it away. - Pablo Picasso"

    },
    {
      id: 5,
      pagename: "Unnati",
      firstComponent: {
        image: Unnati,
        heading: "Project Unnati - Hobby Classes",
        description: "Ishya Foundation organized a Summer Camp for children to explore their creativity, find their passion, socialize and develop various skills. Our first camp kicked off on June 6th, 2022 for 3 weeks at the Kasturba Balika Vidyalaya, Ishwar Nagar, Delhi for children from underprivileged backgrounds.Summer camps are the place where many have had the most memorable experiences of their lives. The children are able to step out of their daily routines and immerse into something new and exciting, learn new skills and make new friends. It was glorious to see the excitement and the immense interest in the activities.",
      },
      theNeed: {
        images: [
          Unnati1,
          Unnati2,
          Unnati3
        ],
        descriptions: [
          "Qualified Instructors and Activity Materials: Skilled professionals for activities like dance, theatre, arts, and crafts, along with activity kits for children to continue practicing independently.",
          "Logistical Support: Adequate space, equipment, and resources to conduct engaging and interactive sessions for the children.",
          "Outreach and Awareness: Efforts to identify and encourage participation from underprivileged children who can benefit from the program.",
         
        ],
      },
      theImpact: {
        subheading: "Project Unnati's Impact:",
        points: [
          "Skill Development and Creativity: Empowered children to explore their talents, develop new skills, and boost self-confidence through creative activities.",
          "Memorable Experiences and Socialization: Provided a fun and enriching environment where children could socialize, make friends, and create lasting memories.",
          "Long-Term Engagement: Equipped children with activity kits and skills to pursue their hobbies independently, fostering continuous learning and passion.",
          
        ],
        image: Unnati4,
      },
      JoinUs: {
        heading: "JOIN US",
        description: "Be a part of our journey to make a difference. Join hands with us and help create a better tomorrow.",
        image:Unnati5,
      },
      quote: "Charity begins at home, but should not end there. - Thomas Fuller"

    },

    {
      id: 6,
      pagename: "Saarthi",
      firstComponent: {
        image: Shiksha,
        heading: "Project Saarthi - Career Counselling",
        description: "Finding the right path for your future is not easy and can often be confusing. Therefore, we at Ishya have begun Career Counselling services for our students to support and guide them in shaping their future. We understand that every student is different and has varying aspirations and to cater to those, we provide tailored guidance to each student. Be it finding the university of your choice, or even a vocational course, we will help you find your path!We test the students aptitude to find their interests and abilities, find available and accurate career options, and design the right way forward while supporting them to lead this journey.",
      },
      theNeed: {
        images: [
          ShikshaSeSakshamNeed1,
          ShikshaSeSakshamNeed2,
          ShikshaSeSakshamNeed3
        ],
        descriptions: [
          "Professional Career Counselors: Access to skilled counselors for personalized career guidance, aptitude tests, and tailored advice.",
          "Awareness and Resources: Information on vocational courses, universities, and career opportunities to help students make informed decisions.",
          "Collaborations with Organizations: Partnerships with institutions like NSDC and other expert organizations to expand career guidance opportunities.",
         
        ],
      },
      theImpact: {
        subheading: "Project Saarthi's Impact:",
        points: [
          "Individualized Career Paths: Enabled students to identify their strengths, weaknesses, and interests, leading to well-suited career choices.",
          "Improved Decision-Making: Provided tools like aptitude tests and expert guidance to help students make confident and informed decisions.",
          "Access to Opportunities: Connected students with vocational courses, universities, and career resources for a variety of aspirations.",
          "Enhanced Skills and Confidence: Motivated students by recognizing their potential and providing actionable steps for career growth.",
          "Collaborative Growth: Built a supportive ecosystem by hosting sessions with organizations and career experts, creating long-term benefits for students."
        ],
        image: ShikshaImpact,
      },
      JoinUs: {
        heading: "JOIN US",
        description: "Be a part of our journey to make a difference. Join hands with us and help create a better tomorrow.",
        image: "/path/to/circular-image.jpg",
      },
      quote: "Giving is not just about making a donation. It is about making a difference. - Kathy Calvin"

    },

    {
      id: 7,
      pagename: "Sahayak",
      firstComponent: {
        image: Sahayak2,
        heading: "Project Sahayak-Aid for Higher Education",
        description: "Ishya supports students who have high potential but lack the financial resources to pay for college fees. The Indian Government's Right to Education Act, 2009 has enabled and increased the enrolling and retaining of students in school, especially from marginalized groups of our society. According to the National Survey for Estimation of Out-of-School Children conducted in 2014, more than 60% of students dropped out before completing 3rd grade and according to the Institute for Policy Research Studies (PRS), nearly 50% of students dropped out by 11th grade .With the existence of such staggering numbers, Ishya is playing a significant role in ensuring that every deserving child receives the opportunity to build a better future through higher education. In order to achieve our vision, we have started the Aid for Higher Education program. We at Ishya help students pursue higher education by providing financial support, so they can continue their education without any barriers.",
      },
      theNeed: {
        images: [
          Sahayak1,
          Saurvi3,
          Saurvi6
        ],
        descriptions: [
          "Professional Career Counselors: Access to skilled counselors for personalized career guidance, aptitude tests, and tailored advice.",
          "Awareness and Resources: Information on vocational courses, universities, and career opportunities to help students make informed decisions.",
          "Robust Selection Process: Implementation of rigorous evaluation methods, including interviews, to ensure scholarships reach the most deserving candidates.",
         
        ],
      },
      theImpact: {
        subheading: "Project Sahayak's Impact:",
        points: [
          "Access to Higher Education: Enabled deserving students to pursue further studies, breaking the cycle of poverty and fostering empowerment.",
          "Reduced Dropout Rates: Provided financial assistance to prevent talented students from discontinuing their education due to economic challenges.",
          "Skill Development and Career Opportunities: Supported students in pursuing specialized courses (e.g., nursing diplomas), opening doors to better career prospects.",
          "Empowerment Through Education: Demonstrated Ishya's belief in education as a tool for long-term societal upliftment.",
          "Inspiring Gratitude and Motivation: Instilled a sense of gratitude in students, motivating them to excel and contribute positively to society."
        ],
        image: ShikshaImpact,
      },
      JoinUs: {
        heading: "JOIN US",
        description: "Be a part of our journey to make a difference. Join hands with us and help create a better tomorrow.",
        image: Sahayak1,
      },
      quote: "Help others without any reason and give without the expectation of receiving anything in return. - Roy T. Bennett"

    },

    {
      id: 8,
      pagename: "Swasthya",
      firstComponent: {
        image: Swasthya1,
        heading: "Project Swasthya: Promoting Health and Wellness in the Community",
        description: "Project Swasthya aims to enhance community health and wellbeing through a multi-faceted approach. The initiative includes organizing free Covid-19 vaccination camps to protect public health, alongside online classes promoting positive health practices, fitness, and hygiene. Additionally, the project has successfully built a soccer team in collaboration with the staff at Alwar School, led by a highly qualified coach. By combining healthcare, education, and sports, Project Swasthya fosters a healthier, more engaged community, empowering individuals to prioritize their physical and mental wellbeing.",
      },
      theNeed: {
        images: [
          Swasthya2,
          Swasthya3,
          Swasthya4
        ],
        descriptions: [
          "Access to Healthcare and Vaccination: Free Covid-19 vaccination camps to ensure the health and safety of the community.",
          "Health and Fitness Education: Online classes to promote positive health, fitness, and hygiene practices.",
          "Sports Infrastructure and Coaching: Resources to develop and support a soccer team, including a qualified coach and training facilities.",
         
        ],
      },
      theImpact: {
        subheading: "Project Swasthya's Impact:",
        points: [
          "Health and Safety: Successfully provided free Covid-19 vaccinations, protecting the community and minimizing the spread of the virus.",
          "Promoted Healthy Lifestyles: Educated individuals on health, fitness, and hygiene, encouraging healthy living practices.",
          "Community Engagement: Developed a strong community through online health classes, increasing awareness and participation in wellness activities.",
          "Youth Empowerment: Built a soccer team with qualified coaching, providing youth with opportunities for physical activity, teamwork, and personal growth.",
          "Enhanced Social Wellbeing: Fostered a sense of unity and collaboration within the community, enhancing social connections through health and sports initiatives.",
        ],
        image: Swasthya5,
      },
      JoinUs: {
        heading: "JOIN US",
        description: "Be a part of our journey to make a difference. Join hands with us and help create a better tomorrow.",
        image: Swasthya6,
      },
      quote: "No act of kindness, no matter how small, is ever wasted. - Aesop"

    },
    // {
    //   id: 9,
    //   firstComponent: {
    //     image: Shiksha,
    //     heading: "Project Shikshan: Empowering Through English Speaking and Skill Development",
    //     description: "Project Shikshan focuses on empowering individuals from marginalized communities by offering English-speaking classes tailored to their abilities and interests. We run small, focused batches with only five students per class to ensure personalized attention and effective learning. In collaboration with MITR Trust in Delhi (a support system for transgenders) and Mehr Chand Mahajan Institute in Dharamshala (a center for women's skill development), we have launched two new batches to help participants gain confidence in English communication. With your support, we aim to expand this initiative globally, enabling more individuals to succeed through language and skills.",
    //   },
    //   theNeed: {
    //     images: [
    //       ShikshaSeSakshamNeed1,
    //       ShikshaSeSakshamNeed2,
    //       ShikshaSeSakshamNeed3
    //     ],
    //     descriptions: [
    //       "Focused Learning Environment: A smaller teacher-to-student ratio to provide personalized attention and ensure effective learning outcomes.",
    //       "Partnerships for Wider Reach: Collaborations with institutions and organizations to extend the program to diverse communities, such as transgender and women’s empowerment groups.",
    //       "Expansion of Resources and Infrastructure: Funding and resources to expand the program internationally and support additional batches.",
         
    //     ],
    //   },
    //   theImpact: {
    //     subheading: "Project Swasthya's Impact:",
    //     points: [
    //       "Increased Confidence: Empowered individuals by improving their English-speaking skills, helping them communicate more confidently in various settings.",
    //       "Inclusivity: Provided valuable language skills to marginalized groups, such as transgenders and women, facilitating their participation in broader social and economic opportunities.",
    //       "Skill Development: Contributed to the holistic development of participants by enhancing language proficiency alongside other vocational skills.",
    //       "Personalized Education: Ensured effective learning through small batch sizes, providing focused attention to each student's progress.",
    //       "Global Outreach: Expanded the reach of Project Shikshan, aiming to support individuals worldwide in their journey toward education and empowerment."
    //     ],
    //     image: ShikshaImpact,
    //   },
    //   JoinUs: {
    //     heading: "JOIN US",
    //     description: "Be a part of our journey to make a difference. Join hands with us and help create a better tomorrow.",
    //     image: "/path/to/circular-image.jpg",
    //   },
    //   quote: "As we work to create light for others, we naturally light our own way. - Mary Anne Radmacher"

    // },

    {
      id: 10,
      pagename: "Kushal Sakhi",
      firstComponent: {
        image: KushalSakhi1,
        heading: "Kushal Sakhi: Empowering Women Through Handmade Crafts",
        description: "The Kushal Sakhi project, spearheaded by Ishya Foundation, is a transformative initiative aimed at uplifting underprivileged women and young girls. Recognizing the immense potential of women and the challenges they face in accessing economic opportunities, Kushal Sakhi focuses on empowering them through the power of handmade crafts. ",
      },
      theNeed: {
        images: [
          KushalSakhi2,
          KushalSakhi4,
          KushalSakhi3
        ],
        descriptions: [
          "Skill Development for Women: Need for training programs in traditional and contemporary crafts to equip women with valuable, marketable skills.",
          "Market Access and Exposure: Need to create opportunities for artisans to access local and global markets through exhibitions and partnerships with retailers.",
          "Financial Empowerment: Need to provide sustainable income streams for women, helping them achieve financial independence and improve their families' quality of life.",
         
        ],
      },
      theImpact: {
        subheading: "Project Kushal Sakhi's Impact:",
        points: [
           "Economic Empowerment: The project has empowered countless women by providing them with the skills and opportunities to earn a livelihood.",
            "Social Impact: Kushal Sakhi has contributed to improving the social and economic status of underprivileged communities.",
            "Cultural Preservation: By promoting traditional crafts, the project helps preserve and promote India's rich cultural heritage."
        ],
        image: KushalSakhi5,
      },
      JoinUs: {
        heading: "JOIN US",
        description: "Be a part of our journey to make a difference. Join hands with us and help create a better tomorrow.",
        image: KushalSakhi6,
      },
      quote: "Philanthropy is commendable, but it must not cause the philanthropist to overlook the circumstances of economic injustice which make philanthropy necessary. - Martin Luther King Jr."

    },
  ];
  
  export default projects;
  